






import { Component, Vue } from "vue-property-decorator";
import DataDisplay from "@/components/DataDisplay.vue";

@Component({
  components: {
    DataDisplay
  }
})
export default class Home extends Vue {}
